import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/base/authentication.service';
import { Domain, Organisation } from '../../../interfaces/routering/organisation';

@Component({
  selector: 'fury-toolbar-webform-link',
  templateUrl: './toolbar-webform-link.component.html',
  styleUrls: ['./toolbar-webform-link.component.scss']
})
export class ToolbarWebformLinkComponent implements OnInit {

  public webformUrl: string = null;

  constructor(private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.authenticationService.organisation$.subscribe((organisation: Organisation): void => {
      const webformUrl: Domain = organisation.domains.find((d: Domain): boolean => d.type.name === 'webform');

      if (webformUrl !== undefined) {
        this.webformUrl = webformUrl.url;
      }
    });
  }

  redirectToWebform(): void {
    window.open(this.webformUrl, '_blank');
  }
}
